import _ from 'lodash';
import api from '../../utils/service';

const GET_BANK_SUCCESS = 'redux/bank/GET_BANK_SUCCESS';
const GET_BANK_FAIL = 'redux/bank/GET_BANK_FAIL';
const CLEAR_BANK = 'redux/bank/CLEAR_BANK';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // NOTE - We ignore failures here b/c it's not an essential service
    case GET_BANK_SUCCESS:
      return {
        ...state,
        ...(action.data || {}),
      };
    case CLEAR_BANK:
      return {
        ...state,
        details: null,
      };
    default:
      return state;
  }
}

export function getBank(routingNumber) {
  return (dispatch) =>
    api
      .get(`/banks?routingNumber=${routingNumber}`)
      .then(({ data }) => dispatch(getBankSuccess(data)))
      .catch((error) => dispatch(getBankFail(error)));
}

export function getBankSuccess(data) {
  return {
    type: GET_BANK_SUCCESS,
    data,
  };
}

export function getBankFail(error) {
  return {
    type: GET_BANK_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function clearBank() {
  return {
    type: CLEAR_BANK,
  };
}
